/** 获取随机Hash值 */
function initHash() {
    var count = 100;
    return function (hashLength) {
        if (hashLength === void 0) { hashLength = 8; }
        var ar = [
            "0",
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "a",
            "b",
            "c",
            "d",
            "e",
            "f",
            "g",
            "h",
            "i",
            "j",
            "k",
            "l",
            "m",
            "n",
            "o",
            "p",
            "q",
            "r",
            "s",
            "t",
            "u",
            "v",
            "w",
            "x",
            "y",
            "z",
        ];
        var hs = [];
        var hl = Number(hashLength);
        var al = ar.length;
        for (var i = 0; i < hl; i++) {
            hs.push(ar[Math.floor(Math.random() * al)]);
        }
        count++;
        return hs.join("") + "".concat(count);
    };
}
var randomHash = initHash();
export default randomHash;
//# sourceMappingURL=randomHash.js.map